import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IpCountryService } from '../../core/services/ip-country.service';
@Injectable()
export class IpCountryInterceptor implements HttpInterceptor {

    constructor(private ipCountryService: IpCountryService) {

     }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      const ipReq = req.clone({
        headers: req.headers.set('ip',  this.ipCountryService.ipCountry.ip).set('country',this.ipCountryService.ipCountry.country)

      });
     return next.handle(ipReq);
    }
}
